/**
 * NostrProvider — provides a relay pool via @nostrify/react's NostrContext.
 * Bridges Concord V2 hooks (which call useNostr()) to real Nostr relays.
 *
 * Default relays: Ditto (primary), Dreamith, nos.lol
 */

import { createElement, useMemo, type ReactNode } from "react";
import { NostrContext } from "@nostrify/react";
import { NPool, NRelay1 } from "@nostrify/nostrify";

/** Default relay pool with Ditto as the primary relay */
export const DEFAULT_RELAYS = [
  "wss://relay.ditto.pub",
  "wss://relay.dreamith.to",
  "wss://nos.lol",
];

export function NostrProvider({ children, relays }: { children: ReactNode; relays?: string[] }) {
  const nostr = useMemo(() => {
    const urls = relays ?? DEFAULT_RELAYS;
    return new NPool({
      open: (url: string) => new NRelay1(url),
      reqRouter: async (filters: any[]) => new Map(urls.map((url) => [url, filters])),
      eventRouter: async () => urls,
    });
  }, []);

  return createElement(NostrContext.Provider, { value: { nostr } }, children);
}